import { styled } from 'styled-components';
import { getFontSize } from '../../abstracts/typography';
import { Link } from '../Link';
export const PasswordFieldMaskingToggle = styled.button.withConfig({
  componentId: "aui__sc-1rtyu9c-0"
})(["border:none;background:none;position:relative;font-size:", ";padding-right:0;padding-left:0;line-height:150%;color:currentColor;cursor:pointer;"], getFontSize(1));
export const ForgotPasswordLink = styled(Link).withConfig({
  componentId: "aui__sc-1rtyu9c-1"
})(["font-size:", ";padding:0 0.75rem;"], getFontSize(1));